// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"107":"b2549ae43bbc6b6c7c79","168":"737805d6287d1c2f4f03"}[chunkId] + ".js";
};